import React, { useEffect, useState } from 'react';
import FormPage from '../../../../shared/Layout/FormPage';
import CustomCard, { CustomGridLayout } from '../../../../shared/Cards/CustomCard';
import { CustomCalenderInput, CustomDropDown, CustomInput } from '../../../../shared/Input/AllInputs';
import formValidation from '../../../../utils/validations';
import CustomTabInput from '../../../../shared/Input/CustomTabInput';
import { useSelector } from 'react-redux';
import PrimaryButton, { CustomButton, CustomButtonGroup, LightButton } from '../../../../shared/Button/CustomButton';
import CustomTabGroup from '../../../../shared/TabView/CustomTabGroup';
import useDepartments from '../../../../hooks/Employees/useDepartments';
import useEmployees from '../../../../hooks/Employees/useEmployees';
import { conditionDropdowns, genderOptions, yesNoOptions } from '../../../../utils/dropdownConstants';
import useCommissionGroup from '../../../../hooks/Inventory/useCommissionGroup';
import CustomPickList from '../../../../shared/Input/CustomPickList';

export default function RuleForm() {
    const [activeTimePeriodIndex, setActiveTimePeriodIndex] = useState(0);
    let employeeOptions = [
        { name: 'Timesheets', value: 'TIMESHEETS' },
        { name: 'Events', value: 'EMPLOYEE_EVENTS' },
        { name: 'Commissions', value: 'COMMISSIONS' },
        { name: 'Tasks', value: 'TASKS' },
        { name: 'Resources', value: 'RESOURCES' },
        { name: 'Inventory', value: 'INVENTORY' },
    ];

    let memberOptions = [
        { name: 'Purchased Service', value: 'PURCHASED_SERVICES' },
        { name: 'Purchased Product', value: 'PURCHASED_PRODUCT' },
        { name: 'Agreement', value: 'AGREEMENT' },
        { name: 'Event', value: 'EVENT' },
        { name: 'Rewards', value: 'REWARDS' },
        { name: 'Tasks', value: 'TASKS' },
        { name: 'Resources', value: 'RESOURCES' },
        { name: 'User Index', value: 'USER_INDEX' },
    ];
    const [data, setData] = useState({
        userType: 'MEMBER',
        ruleType: memberOptions?.value,
        ruleColumns: [],
    });

    const handleChange = ({ name, value }) => {
        const formErrors = formValidation(name, value, data);
        setData((prev) => ({ ...prev, [name]: value, formErrors }));
    };

    let userTypeOptions = [
        { name: 'Member', value: 'MEMBER' },
        { name: 'Employee', value: 'EMPLOYEE' },
    ];

    let { clubsDropdown } = useSelector((state) => state.settings.business);
    const { profitCenterDropdown } = useSelector((state) => state.profitCenter);
    const agreementCategoryDropdown = useSelector((state) => state.settings.agreement.agreementCategoryDropdown);
    const { campaignDropdown } = useSelector((state) => state.settings.members);
    const { eventCategories, eventsDropDown } = useSelector((state) => state.settings.schedule);

    let { departmentsDropdown } = useDepartments();
    let { employeesDropdown } = useEmployees();
    let { commissionGroupDropdown } = useCommissionGroup();

    useEffect(() => {
        if (data.userType) {
            setData((prev) => ({
                ...prev,
                ruleType: data.userType === 'MEMBER' ? 'PURCHASED_SERVICES' : 'TIMESHEETS',
            }));
        }
    }, [data.userType]);

    const timePeriodComponent = () => {
        const timeOptions = ['Specific Date', 'Relative to today', 'All Time'];
        return (
            <>
                <CustomGridLayout>
                    <div className="font-bold text-xl">Time Period</div>
                </CustomGridLayout>

                <CustomGridLayout>
                    <div className="flex gap-3">
                        {timeOptions.map((label, index) => (
                            <div
                                key={index}
                                className={`cursor-pointer border-round-lg text-sm font-regular px-4 py-2 transition-colors duration-200
                  ${activeTimePeriodIndex === index ? 'btn-dark' : 'bg-white text-black'}`}
                                onClick={() => setActiveTimePeriodIndex(index)}
                            >
                                {label}
                            </div>
                        ))}
                    </div>
                </CustomGridLayout>

                <CustomGridLayout>
                    {activeTimePeriodIndex === 0 && <CustomCalenderInput label="Specific Date" onChange={handleChange} name="specificDate" />}
                    {activeTimePeriodIndex === 1 && <CustomInput label="Enter no of days" onChange={handleChange} name="noOfDays" />}
                    {activeTimePeriodIndex === 2 && <div />}
                </CustomGridLayout>
            </>
        );
    };

    const statusOptions = [
        { name: 'Abandoned Cart', value: 'ABANDONED_CART' },
        { name: 'Pending', value: 'PENDING' },
        { name: 'Active', value: 'ACTIVE' },
        { name: 'Expired', value: 'EXPIRED' },
        { name: 'Cancelled', value: 'CANCELLED' },
    ];

    const billingOptions = [
        { name: 'Good Standing', value: 'GOOD_STANDING' },
        { name: 'Declined', value: 'DECLINED' },
        { name: 'Past Due', value: 'PAST_DUE' },
        { name: 'Collection', value: 'COLLECTION' },
    ];

    const eventStatusOptions = [
        { name: 'Booked', value: 'BOOKED' },
        { name: 'Completed', value: 'COMLETED' },
        { name: 'Attended', value: 'ATTENDED' },
        { name: 'Cancelled Charge', value: 'CANCELLED_CHARGE' },
        { name: 'Cancelled No Charge', value: 'CANCELLED_NO_CHARGE' },
    ];

    const eventStatusForEmployeeOptions = [
        { name: 'Completed', value: 'COMLETED' },
        { name: 'Pending', value: 'PENDING' },
        {
            name: 'Attended',
            value: 'ATTENDED',
        },
        {
            name: 'Unattended',
            value: 'UNATTENDED',
        },
    ];

    return (
        <FormPage backText="Rules">
            <CustomCard
                col="12"
                title="Custom Rule"
                extraCard={
                    <>
                        <CustomTabInput className="mt-2" data={data} onChange={handleChange} name="userType" options={userTypeOptions} />
                        <CustomTabInput
                            className="mt-2"
                            data={data}
                            onChange={handleChange}
                            name="ruleType"
                            options={data.userType === 'MEMBER' ? memberOptions : employeeOptions}
                        />
                    </>
                }
            >
                <div className="flex flex-column gap-3 p-2">
                    {data?.ruleType === 'PURCHASED_SERVICES' && (
                        <>
                            <CustomGridLayout>
                                <CustomDropDown data={data} onChange={handleChange} name="club" label="Select Club" options={clubsDropdown} />
                                <CustomDropDown data={data} onChange={handleChange} name="profitCentre" options={profitCenterDropdown} />
                                <CustomDropDown data={data} onChange={handleChange} name="service" label="Item" options={[]} />
                            </CustomGridLayout>
                            <CustomGridLayout>
                                <div className="font-bold text-xl">Number of purchase</div>
                            </CustomGridLayout>
                            <CustomGridLayout>
                                <CustomDropDown data={data} onChange={handleChange} name="quantity" label="Value/Quantity" options={[]} />
                                <CustomDropDown data={data} onChange={handleChange} name="condition" options={conditionDropdowns} />
                                <CustomInput data={data} onChange={handleChange} name={'number'} />
                            </CustomGridLayout>
                            {timePeriodComponent()}
                            <CustomGridLayout>
                                <div className="flex justify-content-end gap-3 w-full mt-3">
                                    <PrimaryButton label="Save" />
                                    <CustomButton label="Cancel" />
                                </div>
                            </CustomGridLayout>
                        </>
                    )}

                    {data?.ruleType === 'PURCHASED_PRODUCT' && (
                        <>
                            <CustomGridLayout>
                                <CustomDropDown data={data} onChange={handleChange} name="club" label="Select Club" options={clubsDropdown} />
                                <CustomDropDown data={data} onChange={handleChange} name="profitCentre" options={profitCenterDropdown} />
                                <CustomDropDown data={data} onChange={handleChange} name="service" label="Item" options={[]} />
                            </CustomGridLayout>
                            <CustomGridLayout>
                                <div className="font-bold text-xl">Number of purchase</div>
                            </CustomGridLayout>
                            <CustomGridLayout>
                                <CustomDropDown data={data} onChange={handleChange} name="quantity" label="Value/Quantity" />
                                <CustomDropDown data={data} onChange={handleChange} name="condition" options={conditionDropdowns} />
                                <CustomInput data={data} onChange={handleChange} name={'number'} />
                            </CustomGridLayout>
                            {timePeriodComponent()}
                            <CustomGridLayout>
                                <div className="flex justify-content-end gap-3 w-full mt-3">
                                    <PrimaryButton label="Save" />
                                    <CustomButton label="Cancel" />
                                </div>
                            </CustomGridLayout>
                        </>
                    )}

                    {data?.ruleType === 'AGREEMENT' && (
                        <>
                            <CustomGridLayout>
                                <CustomDropDown data={data} onChange={handleChange} name="agreementCategory" options={agreementCategoryDropdown} />
                                <CustomDropDown data={data} onChange={handleChange} name="agreementSubCategory" options={[]} />
                                <CustomDropDown data={data} onChange={handleChange} name="agreementName" options={[]} />
                                <CustomDropDown data={data} onChange={handleChange} name="clubSelection" options={clubsDropdown} />
                            </CustomGridLayout>
                            <CustomGridLayout>
                                <div className="font-bold text-xl">Status</div>
                            </CustomGridLayout>
                            <CustomTabGroup tabs={statusOptions} name={'agreementStatus'} data={data} />
                            <CustomGridLayout>
                                <div className="font-bold text-xl">Billing Status</div>
                            </CustomGridLayout>
                            <CustomTabGroup tabs={billingOptions} name={'billingStatus'} data={data} />
                            {timePeriodComponent()}
                            <CustomGridLayout>
                                <div className="flex justify-content-end gap-3 w-full mt-3">
                                    <PrimaryButton label="Save" />
                                    <CustomButton label="Cancel" />
                                </div>
                            </CustomGridLayout>
                        </>
                    )}

                    {data?.ruleType === 'EVENT' && (
                        <>
                            <CustomGridLayout>
                                <CustomDropDown data={data} onChange={handleChange} name="eventType" label="Event Types" options={eventCategories} />
                                <CustomDropDown data={data} onChange={handleChange} name="eventName" options={eventsDropDown} />
                                <CustomDropDown data={data} onChange={handleChange} name="clubSelection" options={clubsDropdown} />
                                <CustomDropDown data={data} onChange={handleChange} name="uniqueInstructor" options={[]} />
                                <CustomDropDown data={data} onChange={handleChange} name="instructor" options={[]} />
                            </CustomGridLayout>
                            <CustomGridLayout>
                                <div className="font-bold text-xl">Event Status</div>
                            </CustomGridLayout>
                            <CustomTabGroup tabs={eventStatusOptions} />

                            <CustomGridLayout>
                                <div className="font-bold text-xl">Completed Events</div>
                            </CustomGridLayout>
                            <CustomGridLayout>
                                <CustomDropDown data={data} onChange={handleChange} name="condition" options={conditionDropdowns} />
                                <CustomInput data={data} onChange={handleChange} name="number" />
                            </CustomGridLayout>
                            {timePeriodComponent()}
                            <CustomGridLayout>
                                <div className="flex justify-content-end gap-3 w-full mt-3">
                                    <PrimaryButton label="Save" />
                                    <CustomButton label="Cancel" />
                                </div>
                            </CustomGridLayout>
                        </>
                    )}

                    {data?.ruleType === 'USER_INDEX' && (
                        <>
                            <CustomGridLayout>
                                <CustomInput data={data} onChange={handleChange} name="minimumAge" />
                                <CustomInput data={data} onChange={handleChange} name="maximumAge" />
                                <CustomDropDown data={data} onChange={handleChange} name="gender" options={genderOptions} />
                                <CustomCalenderInput data={data} name={'birthMonth'} onChange={handleChange} />
                                <CustomInput data={data} onChange={handleChange} name="zipCode" />
                                <CustomDropDown data={data} onChange={handleChange} name="campaign" options={campaignDropdown} />
                                <CustomCalenderInput data={data} name={'profileCreated'} onChange={handleChange} />
                                <CustomDropDown data={data} onChange={handleChange} name="formSubmitted" options={yesNoOptions} />
                                <CustomDropDown data={data} onChange={handleChange} name="optOuts" label={'Opt-outs'} options={[]} />
                                <CustomDropDown data={data} onChange={handleChange} name="relationship" options={[]} />
                                <CustomDropDown data={data} onChange={handleChange} name="clubSelection" options={clubsDropdown} />
                            </CustomGridLayout>
                            {timePeriodComponent()}
                            <CustomGridLayout>
                                <div className="flex justify-content-end gap-3 w-full mt-3">
                                    <PrimaryButton label="Save" />
                                    <CustomButton label="Cancel" />
                                </div>
                            </CustomGridLayout>
                        </>
                    )}

                    {data?.ruleType === 'TIMESHEETS' && (
                        <>
                            <CustomGridLayout>
                                <CustomDropDown data={data} onChange={handleChange} name="department" options={departmentsDropdown} />
                                <CustomDropDown data={data} onChange={handleChange} name="employee" options={employeesDropdown} />
                                <CustomDropDown data={data} onChange={handleChange} name="edited" options={yesNoOptions} />
                                <CustomDropDown data={data} onChange={handleChange} name="includesEmployeePay" options={yesNoOptions} />
                            </CustomGridLayout>
                            <CustomGridLayout>
                                <div className="font-bold text-xl">Number of hours</div>
                            </CustomGridLayout>
                            <CustomGridLayout>
                                <CustomDropDown data={data} onChange={handleChange} name="quantity" />
                                <CustomDropDown data={data} onChange={handleChange} name="condition" options={conditionDropdowns} />
                                <CustomInput data={data} onChange={handleChange} name="number" options={[]} />
                            </CustomGridLayout>
                            {timePeriodComponent()}
                            <CustomGridLayout>
                                <div className="flex justify-content-end gap-3 w-full mt-3">
                                    <PrimaryButton label="Save" />
                                    <CustomButton label="Cancel" />
                                </div>
                            </CustomGridLayout>
                        </>
                    )}

                    {data?.ruleType === 'EMPLOYEE_EVENTS' && (
                        <>
                            <CustomGridLayout>
                                <CustomDropDown data={data} onChange={handleChange} name="department" options={departmentsDropdown} />
                                <CustomDropDown data={data} onChange={handleChange} name="employee" options={employeesDropdown} />
                                <CustomDropDown data={data} onChange={handleChange} name="eventType" options={[]} />
                                <CustomDropDown data={data} onChange={handleChange} name="event" options={[]} />
                            </CustomGridLayout>
                            <CustomGridLayout>
                                <div className="font-bold text-xl">Event Status</div>
                            </CustomGridLayout>

                            <CustomTabGroup tabs={eventStatusForEmployeeOptions} data={data} />
                            <CustomGridLayout>
                                <div className="font-bold text-xl">No of Events</div>
                            </CustomGridLayout>
                            <CustomGridLayout>
                                <CustomDropDown data={data} onChange={handleChange} name="quantity" label={'Value/Quantity'} />
                                <CustomDropDown data={data} onChange={handleChange} name="condition" options={conditionDropdowns} />
                                <CustomDropDown data={data} onChange={handleChange} name="number" options={[]} />
                            </CustomGridLayout>
                            {timePeriodComponent()}
                            <CustomGridLayout>
                                <div className="flex justify-content-end gap-3 w-full mt-3">
                                    <PrimaryButton label="Save" />
                                    <CustomButton label="Cancel" />
                                </div>
                            </CustomGridLayout>
                        </>
                    )}

                    {data?.ruleType === 'COMMISSIONS' && (
                        <>
                            <CustomGridLayout>
                                <CustomDropDown data={data} onChange={handleChange} name="department" options={departmentsDropdown} />
                                <CustomDropDown data={data} onChange={handleChange} name="employee" options={employeesDropdown} />
                                <CustomDropDown data={data} onChange={handleChange} name="commissionGroup" options={commissionGroupDropdown} />
                                <CustomInput data={data} onChange={handleChange} name="discountOrSalesCode" label={'Discount/Sales Code'} options={[]} />
                            </CustomGridLayout>
                            <CustomGridLayout>
                                <div className="font-bold text-xl">Number of sales</div>
                            </CustomGridLayout>
                            <CustomGridLayout>
                                <CustomDropDown data={data} onChange={handleChange} name="quantity" label={'Value/Quantity'} />
                                <CustomDropDown data={data} onChange={handleChange} name="condition" options={conditionDropdowns} />
                                <CustomInput data={data} onChange={handleChange} name="number" options={[]} />
                            </CustomGridLayout>
                            {timePeriodComponent()}
                            <CustomGridLayout>
                                <div className="flex justify-content-end gap-3 w-full mt-3">
                                    <PrimaryButton label="Save" />
                                    <CustomButton label="Cancel" />
                                </div>
                            </CustomGridLayout>
                        </>
                    )}
                </div>
            </CustomCard>
        </FormPage>
    );
}
